import script from "./order.vue?vue&type=script&setup=true&lang=js"
export * from "./order.vue?vue&type=script&setup=true&lang=js"

import "./order.vue?vue&type=style&index=0&id=5158cfbb&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5158cfbb"]])

export default __exports__